import React from 'react';
type YouTubeEmbedProps = {
  videoId: string;
  className?: string;
};
const YouTubeEmbed = ({
  videoId,
  className = ''
}: YouTubeEmbedProps) => {
  return <div className={`aspect-video rounded-custom overflow-hidden shadow-lg ${className}`} data-id="element-424">
      <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&autoplay=0`} title="YouTube video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-425"></iframe>
    </div>;
};
export default YouTubeEmbed;